<template>
  <pop-up-layout 
  :title="$t('reservas.pagos.validandoPago')"
  :ocultarVolver="true"
  >
    <o-base-center-text>
      <v-flex xs12 l10 xl8 class="text-xs-center">
        <p>
        {{$t('reservas.pagos.justificanteEnviado')}}
        </p>
        <p>
          <span v-html="getTexto('pago.validacion', promocion.codigo)"/>
        </p>
      </v-flex>
    </o-base-center-text>
    <v-layout mb-3 justify-center>
      <v-icon color="primary" class="pr-4 custom-icon icon-job" style="font-size:200px;"/>
    </v-layout>
    <v-layout justify-center>
      <v-btn 
        large color="primary"
        @click="$emit('continuar')"
      >
        {{$t('reservas.pagos.continuar')}}
      </v-btn>
    </v-layout>
  </pop-up-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    incrustado: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      inmuebles: 'promociones/inmuebles/getAll',
      promociones: 'promociones/getAll'
    }),
    inmueble () {
      return this.inmuebles[0]
    },
    promocion () {
      return this.promociones[0]
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/reservas/pagos/PagoTransferencia.vue